import { Fragment } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

function ModalImage({ url, onToggle }) {
    return (
        <Fragment>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onToggle();
                }}
                isOpen={Boolean(url)}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark"></h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onToggle();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <img
                                className="al-cursor-pointer"
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                alt="message"
                                src={url}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {/* <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={onToggle}
                    >
                        Cancel
                    </button> */}
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalImage);
